<template>
  <div class="tw-flex tw-flex-1 tw-flex-col tw-justify-between">
    <div>
      <router-link slot="brand" class="navbar-brand tw-block lg:tw-hidden" to="/">
        <img src='@/assets/barter-full.png' alt='logobarter'>
      </router-link>
      <h1 class="tw-mt-6 tw-text-2xl lg:tw-text-3xl">Password Change</h1>
    </div>
    <form role="form">
      <tw-base-input id="ref-password-change-email" data-test-id="ref-password-change-email" label="Email" placeholder="Enter your email" v-model="model.email"/>
      <tw-base-input id="ref-password-change-new-password" data-test-id="ref-password-change-new-password" type="password" label="New Password" placeholder="Enter your new password" v-model="model.new_password"/>
      <tw-base-input id="ref-password-change-confirm-password" data-test-id="ref-password-change-confirm-password" type="password" label="New Password Confirmation" placeholder="Retype your new password" v-model="model.new_password_confirmation"/>
      
      <div class="tw-flex tw-space-x-2 tw-w-full tw-py-4">
        <tw-base-button
          id="ref-password-change-submit"
          data-test-id="ref-password-change-submit"
          type="warning"
          innerClass="tw-p-2"
          size="sm"
          block
          @click.prevent="passwordChange"
          :disabled="loading"
        >
          <a-spin v-if="loading" :spinning="loading" />
          <div v-else>Change Password</div>
        </tw-base-button>
      </div>
    </form>

    <footer class="tw-text-center tw-text-xs tw-mt-6">
      <a id="ref-password-change-login" data-test-id="ref-password-change-login" href="/login" class="tw-text-blue-600">Login to your account</a>
    </footer>
  </div>
</template>
<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import secureStorage from '../../controllers/secureStorage.js'
import { mapState, mapActions} from 'vuex'
import axios from "axios";
var navigate, component_x;

export default {
  mounted: function(){
    navigate = this.$router;
    component_x = this;
  },
  computed: {
    ...mapState(['loggedIn', 'endPoint', 'userEmail']),
  },
  name: 'register',
  data() {
    return {
      model: {
        account_name: '',
        email: '',
        temporary_code: '',
        new_password: '',
        new_password_confirmation: ''
      },
      notification: {},
      loading: false
    }
  },
  methods: {
    ...mapActions(['updateLoggedInStatus', 'updateUserEmail']),
    backTologin(){
      navigate.push('/');
    },
    validation() {
      this.notification = {
        message: '',
        type: 'danger',
        icon: 'fa-circle-xmark'
      }

      if (this.model.email.trim() == '') 
        this.notification.message = "Your email is required for a password change. Please try again."
      if (this.model.new_password.trim() == '') 
        this.notification.message = "Your new password can't be blank. Please try again"
      if (this.model.new_password.trim() !== this.model.new_password_confirmation.trim()) 
        this.notification.message = "Your passwords do not match. Please ensure both passwords are identical."
    },
    async passwordChange(){
      this.$emit('changeAuthLayoutSpinning', true);
      this.loading = true;
      this.validation();

      if (this.notification.message.trim() == '') { 
        this.$emit("handleNotifications", this.notification);
        this.$emit('changeAuthLayoutSpinning', false);
        this.loading = false;
        return; 
      }

      const { acct, tp } = this.$route.query;

      let passwordResetPayload = {
        account_name: acct.trim(),
        email: this.model.email,
        temporary_code: tp.trim(),
        new_password: this.model.new_password
      }

      var post_request = await HTTPRequest.postRequest(this.endPoint + 'users/password_change', null, passwordResetPayload)
      
      if(post_request == undefined){
        this.notification.message = "The temporary code is invalid. Click on 'Forgot Password' for a new code.";
      } else if (post_request.error) {
        this.notification.message = post_request.error;
      } else {
        var bodyFormData = new FormData();
        bodyFormData.set('email', this.model.email);
        bodyFormData.append('password', this.model.new_password);
        bodyFormData.append('grant_type', 'password');
        axios({
          method: 'post',
          url:  this.endPoint.split("/api")[0] + '/oauth/token',
          headers: { "Access-Control-Allow-Origin": "*" },
          data: bodyFormData,
        })
        .then(function (response) {
          var data = response.data
          secureStorage.setItem("accessToken", data["access_token"]);
          secureStorage.setItem("refreshToken", data["refresh_token"]);
          secureStorage.setItem("email", component_x.model.email);
          secureStorage.setItem("loggedIn", true)
          component_x.updateUserEmail(component_x.model.email)
          component_x.updateLoggedInStatus(true)
          navigate.push('dashboard');
        })
        .catch(function (error) {
          this.notification.message = "Something went wrong. An error occured when trying to log in."
        });
        if (this.notification.message.trim() == ''){
          this.notification.message = post_request['success'];
          this.notification.type = "success";
          this.notification.icon = "fa-circle-check";
        }
      }

      this.$emit("handleNotifications", this.notification);
      this.$emit('changeAuthLayoutSpinning', false);
      this.loading = false;
    }
  }
}
</script>
